import { TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { BaseTablePropsType } from "../../../types/container.type";
import { formatAmountDisplay } from "../../../helpers/formatAmountDisplay";
import { formatDate } from "../../../helpers/dateFormatter";

export const JournalEntryTable: React.FC<BaseTablePropsType> = ({ rows }) => {
    const journalEntryTableHeaders = ["Date & Time", "Ref Code", "Performed By", "Branch", "Debit GL", "Credit GL", "Amount", "Narration"];
    return (
        <BaseTable
            headers={journalEntryTableHeaders}
        >
            <TableBody>
                {rows?.map((row, index) => {
                    return (
                        <TableRow
                            key={index}
                        >
                            <TableCell>{formatDate(row?.createdAt, true)}</TableCell>
                            <TableCell>{`${row?.id}`}</TableCell>
                            <TableCell>{row?.performer}</TableCell>
                            <TableCell>{row?.branch}</TableCell>
                            <TableCell>{row?.debitGL?.replace(/\b\w/g, (char: any) => char.toUpperCase())}</TableCell>
                            <TableCell>{row?.creditGL?.replace(/\b\w/g, (char: any) => char.toUpperCase())}</TableCell>
                            <TableCell>{formatAmountDisplay(row?.amount ?? 0)}</TableCell>
                            <TableCell>{row?.description}</TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </BaseTable>
    )
}